import React from 'react';
import { Navigate } from 'react-router';
import { usePermissions } from '../contexts/PermissionsContext';
import Loading from './Common/Loading';

/**
 * ProtectedRoute component that checks page-level permissions before rendering children.
 *
 * @param {string} pageCode - The page code to check permission for (e.g., 'experiments', 'studies')
 * @param {React.ReactNode} children - The components to render if user has permission
 * @param {string} redirectTo - The path to redirect to if user doesn't have permission (default: '/studies')
 */
const ProtectedRoute = ({ pageCode, children, redirectTo = '/studies' }) => {
  const { hasPagePermission, loading } = usePermissions();

  // Show loading state while permissions are being fetched
  if (loading) {
    return <Loading message="Checking permissions..." size="fullscreen" />;
  }

  // Check if user has permission for this page
  if (!hasPagePermission(pageCode)) {
    return <Navigate to={redirectTo} replace />;
  }

  // User has permission, render children
  return children;
};

export default ProtectedRoute;
